<mat-toolbar color="primary" class="custom-primary mat-elevation-z3 customer">
  <button mat-icon-button (click)="drawerOpen = !drawerOpen">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="center-content">
    <span>
      <img class="logo" src="assets/images/logo-candidato.png" alt="">
    </span>
  </div>
</mat-toolbar>

<mat-sidenav-container class="body custom-primary" autosize>
  <mat-sidenav #drawer mode="over" fixedInViewport (openedChange)="onOpenedChange($event)"
    [opened]="drawerOpen === true">
    <div class="profile-info" [ngClass]="{ uploading: progressUpload > 0 }">
      <ng-container *ngIf="avatarPicture; else defaultAvatar">
        <img [src]="avatarPicture" alt="" />
      </ng-container>
      <ng-template #defaultAvatar>
        <img [src]="
            user.gender === 'feminino'
              ? 'assets/images/avatar-female.png'
              : user.gender === 'masculino'
              ? 'assets/images/avatar-male.png'
              : 'assets/images/neutro.png'
          " style="height: 80px; width: auto !important" alt="" />
      </ng-template>
      <button id="avatar-button" mat-icon-button color="primary" (click)="openChooseFile()">
        <mat-icon>add_a_photo</mat-icon>
      </button>
      <input type="file" accept="image/*" style="visibility: hidden; height: 0; width: 0; overflow: hidden"
        (change)="changeAvatar($event)" #fileInput />
    </div>
    <div class="progress-wrapper" *ngIf="progressUpload > 0">
      <mat-progress-bar mode="determinate" style="z-index: 999" [value]="progressUpload"></mat-progress-bar>
    </div>

    <mat-nav-list dense>

      <ng-container *ngFor="let item of menu">

        <ng-container *ngIf="item.routerLink">
          <a mat-list-item [routerLink]="item.routerLink" (click)="drawerOpen = false" routerLinkActive="active">
            <mat-icon matListIcon>{{ item.icon }}</mat-icon>
            {{ item.label }}
          </a>
        </ng-container>

        <ng-container *ngIf="item.click">
          <a mat-list-item (click)="item.click()" routerLinkActive="active">
            <mat-icon matListIcon>{{ item.icon }}</mat-icon>
            {{ item.label }}
          </a>
        </ng-container>

      </ng-container>

      <mat-divider></mat-divider>
      <a mat-list-item style="color: red !important" (click)="logout()">
        <mat-icon matListIcon>logout</mat-icon>
        Sair dessa conta
      </a>

      <a *ngIf="isFlutterApp" mat-list-item style="color: #f0f !important" (click)="exitApp()">
        <mat-icon matListIcon>exit_to_app</mat-icon>
        Sair do aplicativo
      </a>

    </mat-nav-list>
    <app-version-link customClass="version2"></app-version-link>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="container">
      <div class="stage">
        <div class="main-content mat-elevation-z3">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>